import type { Media } from '@/payload-types'

export function getSeasonalMedia(
  winter?: { media: string | Media } | null,
  summer?: { media: string | Media } | null,
  fallbackMedia?: string | Media | null,
  date?: Date,
): string | Media | null {
  // Use provided date or get current date
  const currentDate = date || new Date()
  const currentMonth = currentDate.getMonth() + 1 // getMonth() returns 0-11

  // Winter months: December (12), January (1), February (2)
  const isWinter = currentMonth <= 2 || currentMonth >= 10

  // Summer months: June (6), July (7), August (8)
  const isSummer = !isWinter
  // const isSummer = currentMonth >= 3 && currentMonth <= 5

  if (isWinter && winter?.media) {
    return winter.media
  }

  if (isSummer && summer?.media) {
    return summer.media
  }

  // Fallback to the default media if seasonal media is not available
  return fallbackMedia || null
}
